import React from 'react';
import { FormFeedback } from 'Components/frameworks/form-feedback/FormFeedback';
type Props = {
  className?: string;
  dataTestId?: string;
  texts: Array<string>;
};
export const FormErrors = ({ className, dataTestId, texts = [] }: Props) => (
  <div className={className} data-testid={dataTestId}>
    {texts.map((text) => (
      <FormFeedback key={text} isError message={text} />
    ))}
  </div>
);
